import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const BRAND = '#22c55e';
const GOLD = '#eab308';

// Landing pro DONO DE TIME (comunidade.futezap.com.br/time) — momento
// de conversao: entrar ou criar conta. Layout dark premium, mesma
// linguagem visual da quadra animada da convocacao.

export default function TeamCommunityLanding() {
  const nav = useNavigate();
  const [logged, setLogged] = useState(false);
  const [teamId, setTeamId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('community_token');
    if (!token) return;
    setLogged(true);
    api.get('/community/team-owner/my').then(r => {
      const t = r.data.teams?.[0];
      if (t) setTeamId(t.id);
    }).catch(() => {});
  }, []);

  const goToStart = () => {
    if (logged) {
      if (teamId) nav(`/time/dashboard/${teamId}`);
      else nav('/time/setup');
    } else {
      nav('/player/login?next=/time/setup');
    }
  };

  const ctaLabel = logged
    ? (teamId ? 'Voltar pro meu painel' : 'Continuar cadastro')
    : 'Criar meu time';

  return (
    <div style={{
      minHeight: '100vh',
      background: `
        radial-gradient(ellipse 800px 400px at 50% 0%, rgba(234,179,8,0.08), transparent 70%),
        radial-gradient(ellipse 600px 300px at 20% 40%, rgba(34,197,94,0.06), transparent 70%),
        #050a12`,
      color: '#f8fafc',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: '24px 16px 48px',
    }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        {/* Header minimalista */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 40 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: `linear-gradient(135deg, ${BRAND}, #16a34a)`,
            display: 'grid', placeItems: 'center', fontSize: 18,
            boxShadow: `0 8px 20px -6px ${BRAND}66`,
          }}>⚽</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: -0.3 }}>Futezap Comunidade</div>
            <div style={{ fontSize: 10, color: '#64748b', letterSpacing: 1.5, fontWeight: 700 }}>PRO ORGANIZADOR</div>
          </div>
        </div>

        {/* Hero */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '5px 12px', borderRadius: 999,
            background: 'rgba(234, 179, 8, 0.12)',
            border: '1px solid rgba(234, 179, 8, 0.3)',
            color: GOLD, fontSize: 11, fontWeight: 800, letterSpacing: 1.5,
            marginBottom: 20,
          }}>
            ⭐ GRÁTIS PRA CRIAR · SEM CARTÃO
          </div>
          <h1 style={{
            fontSize: 'clamp(30px, 5vw, 48px)',
            fontWeight: 900, letterSpacing: -1.5, lineHeight: 1.05,
            margin: 0, color: '#f8fafc',
          }}>
            Chega de correr no zap<br />
            <span style={{
              background: `linear-gradient(90deg, ${BRAND}, ${GOLD})`,
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>perguntando quem vai</span>
          </h1>
          <p style={{
            fontSize: 16, color: '#94a3b8', maxWidth: 560,
            margin: '18px auto 0', lineHeight: 1.5,
          }}>
            Convocação com um clique no email, lista sendo preenchida em tempo real
            e elenco na palma da mão. Do jeito que boleiro entende.
          </p>
        </div>

        {/* CTA duplo */}
        <div style={{
          display: 'flex', flexDirection: 'column', gap: 10,
          maxWidth: 420, margin: '0 auto 32px', width: '100%',
        }}>
          <button onClick={goToStart}
            style={{
              all: 'unset', cursor: 'pointer', textAlign: 'center',
              padding: '18px 24px', borderRadius: 14,
              background: `linear-gradient(135deg, ${BRAND}, #16a34a)`,
              color: '#fff', fontWeight: 900, fontSize: 17, letterSpacing: -0.3,
              boxShadow: `0 14px 30px -8px ${BRAND}70`,
              transition: 'transform 0.15s, box-shadow 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            {ctaLabel} →
          </button>
          {!logged && (
            <button onClick={() => nav('/player/login?next=/time/setup')}
              style={{
                all: 'unset', cursor: 'pointer', textAlign: 'center',
                padding: '14px 24px', borderRadius: 14,
                background: 'transparent', color: '#94a3b8',
                border: '1px solid rgba(148,163,184,0.2)',
                fontWeight: 700, fontSize: 14,
              }}>
              Já tenho conta — entrar
            </button>
          )}
        </div>

        {/* Preview do produto: quadra + explicacao */}
        <div style={{
          background: '#0f172a',
          border: '1px solid rgba(148,163,184,0.12)',
          borderRadius: 24,
          padding: 28,
          marginBottom: 24,
          boxShadow: '0 30px 60px -20px rgba(0,0,0,0.6)',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8,
            marginBottom: 20,
          }}>
            <div style={{
              width: 8, height: 8, borderRadius: 4, background: BRAND,
              boxShadow: `0 0 12px ${BRAND}`,
            }} />
            <div style={{
              fontSize: 10, letterSpacing: 1.8, fontWeight: 800,
              color: '#94a3b8',
            }}>PREVIEW AO VIVO</div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 240px) 1fr',
            gap: 24, alignItems: 'center',
          }}>
            {/* Mini quadra */}
            <div style={{
              background: '#063220', borderRadius: 16, overflow: 'hidden',
              boxShadow: 'inset 0 0 40px rgba(0,0,0,0.3)',
              aspectRatio: '3 / 4',
            }}>
              <svg viewBox="0 0 300 400" style={{ width: '100%', height: '100%', display: 'block' }} preserveAspectRatio="xMidYMid meet">
                <defs>
                  <pattern id="lp2-stripes" x="0" y="0" width="300" height="50" patternUnits="userSpaceOnUse">
                    <rect width="300" height="50" fill="#0a4a2e"/>
                    <rect y="25" width="300" height="25" fill="#0d5c39"/>
                  </pattern>
                </defs>
                <rect width="300" height="400" fill="url(#lp2-stripes)"/>
                <rect x="14" y="14" width="272" height="372" fill="none" stroke="rgba(244,244,245,0.85)" strokeWidth="2" rx="2"/>
                <line x1="14" y1="200" x2="286" y2="200" stroke="rgba(244,244,245,0.85)" strokeWidth="2"/>
                <circle cx="150" cy="200" r="42" fill="none" stroke="rgba(244,244,245,0.85)" strokeWidth="2"/>
                <circle cx="150" cy="200" r="3" fill="rgba(244,244,245,0.85)"/>
                <rect x="70" y="14" width="160" height="60" fill="none" stroke="rgba(244,244,245,0.85)" strokeWidth="2"/>
                <rect x="70" y="326" width="160" height="60" fill="none" stroke="rgba(244,244,245,0.85)" strokeWidth="2"/>
                {[
                  { x: 90, y: 120, shirt: BRAND },
                  { x: 210, y: 120, shirt: BRAND },
                  { x: 150, y: 152, shirt: BRAND },
                  { x: 66, y: 232, shirt: BRAND },
                  { x: 234, y: 232, shirt: BRAND },
                  { x: 105, y: 272, shirt: BRAND },
                  { x: 195, y: 272, shirt: BRAND },
                  { x: 150, y: 36, shirt: '#94a3b8', small: true },
                  { x: 90, y: 372, shirt: '#475569', out: true },
                ].map((p, i) => (
                  <g key={i} opacity={p.out ? 0.5 : 1}>
                    <ellipse cx={p.x} cy={p.y + 22} rx="9" ry="1.6" fill="rgba(0,0,0,0.5)"/>
                    <rect x={p.x - 9} y={p.y - 6} width="18" height="20" rx="3" fill={p.shirt}/>
                    <circle cx={p.x} cy={p.y - 12} r="5.5" fill="#fbbf24"/>
                  </g>
                ))}
                <rect x="120" y="6" width="60" height="14" rx="7" fill="rgba(0,0,0,0.4)"/>
                <text x="150" y="16" textAnchor="middle" fill="rgba(255,255,255,0.65)" fontSize="8" fontWeight="700" letterSpacing="1.5">ESPERA</text>
                <rect x="128" y="380" width="45" height="14" rx="7" fill="rgba(0,0,0,0.4)"/>
                <text x="150" y="390" textAnchor="middle" fill="rgba(255,255,255,0.65)" fontSize="8" fontWeight="700" letterSpacing="1.5">FORA</text>
              </svg>
            </div>

            {/* Copy explicativo do preview */}
            <div>
              <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: -0.5, marginBottom: 8 }}>
                Você acompanha a lista <span style={{ color: BRAND }}>sendo preenchida em tempo real</span>
              </div>
              <div style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.6, marginBottom: 16 }}>
                Cada boleiro que confirma entra em campo. Quem tá na espera fica em cima.
                Quem não vai, fica apagadinho embaixo. Você vê tudo — inclusive no celular, durante o dia.
              </div>
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                {[
                  { c: BRAND, l: '7 dentro' },
                  { c: '#94a3b8', l: '1 na espera' },
                  { c: '#475569', l: '1 fora' },
                ].map((s, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#cbd5e1' }}>
                    <span style={{
                      width: 10, height: 10, borderRadius: 5, background: s.c,
                      boxShadow: `0 0 8px ${s.c}88`,
                    }} />
                    <strong>{s.l}</strong>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Grid de features do painel */}
        <div style={{
          fontSize: 10, letterSpacing: 2, fontWeight: 800,
          color: '#94a3b8', textAlign: 'center', margin: '8px 0 16px',
        }}>TUDO NO PAINEL DO TIME</div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: 12, marginBottom: 24,
        }}>
          {[
            {
              ic: '⚽', badge: 'NOVO', t: 'Convocação com campo animado',
              d: 'O jogador clica no email e responde. A lista de confirmados atualiza em tempo real no painel.',
            },
            {
              ic: '🤝', t: 'Amistosos',
              d: 'Marca amistoso com outro time da comunidade sem precisar do telefone do organizador. Convite e resposta pelo próprio app.',
            },
            {
              ic: '📅', t: 'Tabela de jogos',
              d: 'Agenda organizada dos próximos jogos, com quadra, hora e adversário. Todo mundo do time vê a mesma coisa.',
            },
            {
              ic: '👥', t: 'Elenco unificado',
              d: 'Cadastro do jogador uma vez só. Se ele já tá na comunidade, os dados vêm completos — sem digitar de novo.',
            },
            {
              ic: '📋', t: 'Escalação pré-jogo',
              d: 'Monta os times antes da pelada, exporta pra galera. Sem correria dividindo time na quadra.',
            },
            {
              ic: '💰', t: 'Cobrança da mensalidade',
              d: 'Cobra a galera pelo Pix ou cartão, acompanha quem pagou. Chega de perseguir cada um no zap.',
            },
          ].map((f, i) => (
            <div key={i} style={{
              position: 'relative',
              background: '#0f172a',
              border: '1px solid rgba(148,163,184,0.12)',
              borderRadius: 16,
              padding: 20,
            }}>
              {f.badge && (
                <div style={{
                  position: 'absolute', top: 14, right: 14,
                  padding: '2px 8px', borderRadius: 999,
                  background: 'rgba(234,179,8,0.15)',
                  border: '1px solid rgba(234,179,8,0.35)',
                  color: GOLD, fontSize: 9, fontWeight: 900, letterSpacing: 1.5,
                }}>{f.badge}</div>
              )}
              <div style={{
                width: 42, height: 42, borderRadius: 12,
                background: `linear-gradient(135deg, ${GOLD}, #ca8a04)`,
                display: 'grid', placeItems: 'center', fontSize: 20,
                marginBottom: 12,
                boxShadow: '0 8px 18px -6px rgba(234, 179, 8, 0.4)',
              }}>{f.ic}</div>
              <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 4, letterSpacing: -0.2 }}>{f.t}</div>
              <div style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.5 }}>{f.d}</div>
            </div>
          ))}
        </div>

        {/* Créditos */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(234,179,8,0.08), rgba(234,179,8,0.02))',
          border: '1px solid rgba(234, 179, 8, 0.25)',
          borderRadius: 16, padding: 20, marginBottom: 32,
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
            <div style={{ fontSize: 26 }}>💳</div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.5, color: GOLD, marginBottom: 4 }}>
                COMO FUNCIONAM OS CRÉDITOS
              </div>
              <div style={{ fontSize: 14, color: '#e2e8f0', lineHeight: 1.6 }}>
                Cadastro do time, elenco e criar convocação são <strong>grátis</strong>. Você
                compra crédito só pra mandar mesmo — <strong style={{ color: GOLD }}>1 crédito = 1 whatsapp OU 10 emails OU 10 telegram</strong>.
                Sem mensalidade. Compra e usa quando quiser.
              </div>
            </div>
          </div>
        </div>

        {/* Como funciona 3 passos */}
        <div style={{ marginBottom: 32 }}>
          <div style={{
            fontSize: 10, letterSpacing: 2, fontWeight: 800,
            color: '#94a3b8', textAlign: 'center', marginBottom: 20,
          }}>COMEÇA EM 3 PASSOS</div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 12,
          }}>
            {[
              { n: '1', t: 'Cadastra o time', d: 'Nome, quadra e dias que jogam. 2 minutos. Grátis.' },
              { n: '2', t: 'Monta o elenco', d: 'Adiciona a galera. Jogador já cadastrado na comunidade vem completo, sem digitar de novo.' },
              { n: '3', t: 'Usa tudo do painel', d: 'Agenda jogo, convoca a galera, escala os times, cobra mensalidade, marca amistoso. Tudo num só lugar.' },
            ].map((s) => (
              <div key={s.n} style={{
                position: 'relative', paddingLeft: 60,
                minHeight: 80,
              }}>
                <div style={{
                  position: 'absolute', left: 0, top: 0,
                  width: 44, height: 44, borderRadius: 12,
                  background: '#0f172a',
                  border: `1px solid ${BRAND}55`,
                  color: BRAND, fontSize: 20, fontWeight: 900,
                  display: 'grid', placeItems: 'center',
                }}>{s.n}</div>
                <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 4, letterSpacing: -0.2 }}>{s.t}</div>
                <div style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.5 }}>{s.d}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA final grande */}
        <div style={{
          background: `linear-gradient(135deg, #0f172a, #1e293b)`,
          border: `1px solid ${BRAND}33`,
          borderRadius: 24, padding: '32px 24px', textAlign: 'center',
          marginBottom: 20,
        }}>
          <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.5, marginBottom: 8 }}>
            Bora testar? Leva 2 minutos.
          </div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 20 }}>
            Cria conta, cadastra o time e tá dentro. Sem cartão, sem enrolação.
          </div>
          <button onClick={goToStart}
            style={{
              all: 'unset', cursor: 'pointer', display: 'inline-block',
              padding: '16px 32px', borderRadius: 14,
              background: `linear-gradient(135deg, ${BRAND}, #16a34a)`,
              color: '#fff', fontWeight: 900, fontSize: 15, letterSpacing: -0.2,
              boxShadow: `0 14px 30px -8px ${BRAND}70`,
            }}>
            {ctaLabel} →
          </button>
        </div>

        {/* Nota discreta sobre Futezap Pro */}
        <div style={{
          padding: '14px 18px',
          background: 'rgba(255,255,255,0.02)',
          border: '1px solid rgba(148,163,184,0.08)',
          borderRadius: 12,
          fontSize: 12, color: '#64748b', lineHeight: 1.6,
        }}>
          <strong style={{ color: '#94a3b8' }}>Já organiza time com chip próprio?</strong>{' '}
          O Futezap Pro (pago) automatiza a convocação no WhatsApp direto do chip, ranking, MVP. Ativa
          trial de 30 dias pelo painel depois de criar o time.
        </div>

        <div style={{ textAlign: 'center', color: '#475569', fontSize: 11, marginTop: 30 }}>
          Feito no Brasil 🇧🇷 pra quem joga bola.
        </div>
      </div>
    </div>
  );
}
